import React from 'react'
import { connect } from 'react-redux'
import Login from './login'
import Landing from './landing'
import { toast, collapseToast, ToastContainer } from 'react-toastify'
import { subscriptionPlansFetchRequest } from '../../action/subscription-plan-actions'
import Firebase from './firebase'
import SplashScreen from './splash-screen'
import PropsRoute from './propsRoute'
import isNil from 'lodash/isNil'
import localForage from 'localforage'
import { logout } from '../../action/auth-actions'
import { collapseLeftToolbar } from '../../action/left-toolbar-state-actions'
import { enableMapObject } from '../../action/disable-map-obj-state-action'
import Merchant from './merchant-modals'
import Toast from '../main-ui/toast'
import { Route, Routes, Navigate } from 'react-router-dom';
import PasswordReset from './login/password-reset';
import { setLoading } from '../../action/loading-actions'
import GoogleThreeD from '../threedmap/threedemap'

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      login: false,
      signup: false,
      scriptsLoaded: true
    }
    if (this.props.subscriptionPlans.length === 0) {
      this.props.subscriptionPlansFetchRequest()
    }
  }

  componentWillMount() {
    if (window.location.pathname === '/password-reset') {
      this.props.logout()
      this.props.setLoading(false)
    }
  }

  componentDidMount() {
    this.props.collapseLeftToolbar()
    this.props.enableMapObject()  //bug 6264 pavan
  }

  testNotification() {
    Toast.baseMapSubscription()
  }

  // getComponent() {
  //   if (window.location.pathname.toLowerCase() === '/eastmansprotrial') {
  //     if (isNil(this.props.auth) || isNil(this.props.auth.token)) {
  //       const pNamePro = window.location.pathname.toLowerCase()
  //       switch (pNamePro) {
  //         case '/eastmansprotrial':
  //           return EastmansProTrial
  //         default:
  //           localForage.setItem('persist:basemap', {})
  //           return Login
  //       }
  //     }
  //   }

  //   if (isNil(this.props.auth) || isNil(this.props.auth.token)) {
  //     localForage.setItem('persist:basemap', {})
  //     return Login
  //   }

  //   const pName = window.location.pathname,
  //     typeReg = RegExp('type'),
  //     subReg = RegExp('subscribe')

  //   if (typeReg.test(window.location.search) && !subReg.test(pName)) {
  //     return SubscriptionInfo
  //   }

  //   switch (pName) {
  //     case '/claim':
  //       return Merchant
  //     case '/redeem':
  //       return Merchant
  //     case '/subscribe':
  //       return SubscriptionInfo
  //     case '/evbma':
  //       return MerchantDiscountAnnually
  //     case '/evbmm':
  //       return MerchantDiscountMonthly
  //     default:
  //       return Landing
  //   }
  // }


  getComponent() {
    if (window.location.pathname.toLowerCase() === '/eastmansprotrial') {
      if (isNil(this.props.auth) || isNil(this.props.auth.token)) {
        const pNamePro = window.location.pathname.toLowerCase();
        switch (pNamePro) {
          case 'eastmansprotrial':
            return EastmansProTrial;
          default:
            localForage.setItem('persist:basemap', {});
            return Login;
        }
      }
    }

    if (isNil(this.props.auth) || isNil(this.props.auth.token)) {
      localForage.setItem('persist:basemap', {});
      return Login;
    }

    const pName = window.location.pathname,
      typeReg = RegExp('type'),
      subReg = RegExp('subscribe');

    if (typeReg.test(window.location.search) && !subReg.test(pName)) {
      return SubscriptionInfo;
    }

    switch (pName) {
      case '/claim':
        return Merchant;
      case '/redeem':
        return Merchant;
      case '/subscribe':
        return SubscriptionInfo;
      case '/evbma':
        return MerchantDiscountAnnually;
      case '/evbmm':
        return MerchantDiscountMonthly;
      default:
        return Landing;
    }
  }


  render() {
    const Component = this.getComponent();
    const { auth } = this.props;
    const isAuthenticated = !isNil(auth) && !isNil(auth.token);
    return (
      <div className="app">
        <SplashScreen />
        <ToastContainer
          autoClose={5000}
          closeButton={false}
          position="bottom-center" />
        <Firebase>
          <Routes>
            {/* Public Routes */}
            <Route
              path="password-reset"
              element={<PasswordReset />}
            />
            <Route
              path="claim"
              element={isAuthenticated ? <Merchant /> : <Navigate to="/login" />}
            />
            <Route
              path="redeem"
              element={isAuthenticated ? <Merchant /> : <Navigate to="/login" />}
            />
            <Route
              path="/"
              element={isAuthenticated ? <Landing /> : <Login />}
            />

            <Route
              path="/three-d-maps"
              element={isAuthenticated ? <GoogleThreeD /> : <Login />}
            />

            {/* Catch-all Route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Firebase>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  user: state.user,
  subscriptionPlans: state.subscriptionPlans
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  logout: () => dispatch(logout()),
  subscriptionPlansFetchRequest: () => dispatch(subscriptionPlansFetchRequest()),
  enableMapObject: () => dispatch(enableMapObject()),
  setLoading: (payload) => dispatch(setLoading(payload))
})

export default connect(mapStateToProps, mapDispatchToProps)(App)
